import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "./services/authentication.service";

@Injectable()
export class AuthResolver implements Resolve<any> {
    constructor(
        private authService: AuthenticationService
    ) { }

    async resolve(route: ActivatedRouteSnapshot) {
        return await this.authService.authorize();
    }
}
